import { createAction } from "@reduxjs/toolkit";
import { ApiActionPayload } from "../types/utilityActions";
import { RootState } from "./store";

export const historyPush = createAction<string>("historyPush");
export const api = createAction<ApiActionPayload>("api");
export const hydrateState = createAction<RootState>("hydrateState");
